export default {
  enums: [
    { id: 'PRODUCT' },
    { id: 'PRODUCT_PACKAGE' },
    { id: 'PRODUCT_LABEL' }
  ]
};